import styled from 'styled-components'

export const WrapperLoading = styled.div`
  align-self: center;
`
